export default "__VITE_ASSET__ad27941b__"